export const isValidJSON = (data) => {
	try {
		JSON.parse(data);
		return true;
	} catch (err) {
		return false;
	}
};

export const generateUniqueId = () => {
	const timestamp = Date.now().toString(36);
	const random = Math.random().toString(36).slice(2, 7);
	return timestamp + random;
};

export const formatApiResponseData = (data) => {
	return {
		error: !!data?.error,
		message: data?.message || "",
		...data?.data,
	};
};
